import { render } from "./AddNoBidAnswerModal.vue?vue&type=template&id=cc82bb8a"
import script from "./AddNoBidAnswerModal.vue?vue&type=script&lang=js"
export * from "./AddNoBidAnswerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__